import ChooseSide from '@components/HomePage/ChooseSide/ChooseSide';


const HomePage = () => {
   return (
       <>
            <h1 className="header_text">HomePage</h1>
            <ChooseSide></ChooseSide>
       </>
   )
}
export default HomePage;